import React from "react";
import Appbar from "../NavBar/Appbar";
import "./smilow.css";
import SendDialog from "../NavBar/SendDialog";
import smilow_logo from "./smilow_logo.png";
import jason_face from "./smilow_jason.png";
import smilow_doctor from "./smilow_doctoricon.png";
import smilow_1 from "./smilow_option1.png";
import smilow_2 from "./smilow_option2.png";
import smilow_3 from "./smilow_option3.png";
import Carousel from "nuka-carousel";
import "../CarouselElements/pillcard.css";

class Smilow extends React.Component {
  //True for switch means Classes
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.screen.width
    };
    var that = this;
    // Listen for orientation changes
    window.addEventListener(
      "orientationchange",
      function() {
        // Announce the new orientation number
        that.resize();
      },
      false
    );
  }
  resize() {
    this.setState({ windowWidth: window.screen.width });
  }

  render() {
    let noOfSlides = 3;
    if (this.state.windowWidth >= 915) {
      noOfSlides = 3;
    } else {
      noOfSlides = 2;
    }
    return (
      <div className="smilow-choice-div">
        <div className="dashboard">
          <div className="horizontal">
            <img className="smilow-logo" src={smilow_logo} />
            <div className="smilow-title">Smilow Choice</div>
          </div>
          <div className="horizontal">
            <img className="jason-face" src={jason_face} />
            <div className="smilow-title">Dr. John Doe</div>
          </div>
          <div className="message">
            <p>Dear Jane,</p>
            You were really brave on your last visit. As a doctor I dispense
            advice on a daily basis, and I can indeed help you narrow down what
            options to choose between. As we discussed, for your particular
            stage, our team thinks that the three options here would be
            effective in helping to treat the cancer. Here are some things I
            think you should consider. The surgery and hormone therapy will have
            the least ....
          </div>
          <div className="horizontal">
            <img className="smilow-doctor-face" src={smilow_doctor} />
            <div className="smilow-title small">How to use Smilow Choice</div>
          </div>
          <div className="horizontal">
            <div className="number">1</div>
            <div className="small instruction">
              Pick your preferred treatment.{" "}
            </div>
          </div>
          <div className="horizontal">
            <div className="number">2</div>
            <div className="small instruction">How to use Smilow Choice</div>
          </div>
        </div>
        <div className="medbase">
          <Appbar>
            <div className="patient-name">
              <span>Hello, Jane Doe</span>
            </div>
            <div className="appointment">
              <span>Next Appointment: 4/5/2019</span>
            </div>
            <SendDialog url={"/smilow"} />
          </Appbar>
          <Carousel
            slidesToShow={noOfSlides}
            withoutControls={true}
            heightMode="max"
            swiping={true}
            renderBottomCenterControls={null}
            renderCenterLeftControls={null}
            renderCenterRightControls={null}
          >   
          {/* Pill 1 */}
          <div className="smilow-external">
                <div style={{"background-color": "#1890ff"}} className="pill-class">
                    <div className="medName">Surgery & Hormone Therapy </div>
                </div>
                <div className="smilow-pillcard">
                  <img classname="smilow-card" style={{'width': '100%'}} src={smilow_1} />
                </div>
              </div>
          {/* Pill 2 */}
          <div className="smilow-external">
                <div style={{"background-color": "pink"}} className="pill-class">
                    <div className="medName">Surgery & Hormone Therapy & <span style={{"color": "#1890ff"}} >2nd Gen Chemo</span> </div>
                </div>
                <div className="smilow-pillcard">
                  <img classname="smilow-card" style={{'width': '100%'}} src={smilow_2} />
                </div>
              </div>
          {/* Pill 3 */}
          <div className="smilow-external">
                <div style={{"background-color": "yellow"}} className="pill-class">
                    <div className="medName">Surgery & Hormone Therapy & <span style={{"color": "#1890ff"}} >2nd Gen Chemo</span> & <span style={{"color": "orange"}} >Trastuzumab</span></div>
                </div>
                <div className="smilow-pillcard">
                  <img classname="smilow-card" style={{'width': '100%'}} src={smilow_3} />
                </div>
              </div>
          </Carousel>
        </div>
      </div>
    );
  }
}

export default Smilow;



// WEBPACK FOOTER //
// ./src/Pillcards/Smilow.js